<h2 mat-dialog-title i18n>Community Built</h2>
<div mat-dialog-content>
  <div class="info-block">
    <p i18n>
      "Community Built" units are designed and contributed by WISE community members. Want to
      publicly share your custom unit?
      <a routerLink="/contact" target="_blank">Contact Us</a>!
    </p>
    <p class="mat-caption" i18n>
      *Please note: While WISE staff have reviewed these units, we cannot specifically vouch for
      their effectiveness or quality. Please examine the units carefully before using in your
      classrooms. Thanks!
    </p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()" i18n>Close</button>
</div>
